const getMainImage = (card) => card.querySelector('.product-card__image');

const normalizeSrc = (src) => (src ? src.replace(/^https?:/, '') : '');

const getNextImage = (thumb) => {
  const fullSrc = thumb.dataset.fullSrc || thumb.currentSrc || thumb.src;
  if (!fullSrc) return null;

  return {
    src: fullSrc,
    srcset: thumb.dataset.fullSrcset || '',
    alt: thumb.alt || '',
  };
};

const applyLoadingState = (card, mainImage) => {
  if (!card) return () => {};

  card.classList.add('product-card--image-loading');

  const clear = () => {
    card.classList.remove('product-card--image-loading');
    mainImage.removeEventListener('load', clear);
    mainImage.removeEventListener('error', clear);
  };

  mainImage.addEventListener('load', clear);
  mainImage.addEventListener('error', clear);

  requestAnimationFrame(() => {
    if (mainImage.complete) {
      clear();
    }
  });

  return clear;
};

const updateMainImage = (mainImage, nextImage) => {
  mainImage.src = nextImage.src;

  if (nextImage.srcset) {
    mainImage.srcset = nextImage.srcset;
  } else {
    mainImage.removeAttribute('srcset');
  }

  if (nextImage.alt) {
    mainImage.alt = nextImage.alt;
  }
};

document.addEventListener('click', (event) => {
  const thumb = event.target.closest('.product-card__thumb');
  if (!thumb || !(thumb instanceof HTMLImageElement)) return;

  const card = thumb.closest('.product-card');
  if (!card) return;

  const mainImage = getMainImage(card);
  if (!mainImage) return;

  const nextImage = getNextImage(thumb);
  if (!nextImage) return;

  const currentSrc = normalizeSrc(mainImage.currentSrc || mainImage.src);
  const nextSrc = normalizeSrc(nextImage.src);

  if (currentSrc && nextSrc && currentSrc === nextSrc) return;

  event.preventDefault();
  event.stopPropagation();

  applyLoadingState(card, mainImage);
  updateMainImage(mainImage, nextImage);
});
